module.exports = __webpack_public_path__ + "img/stars.c33f8845.svg";